import { FaInstagram, FaFacebookF, FaYoutube } from "react-icons/fa";
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="ceylon-footer">

      <div className="container pt-5 pb-2">

        <div className="row gy-5">

          {/* ================= Column 1 ================= */}
          <div className="col-12 col-md-6 col-lg-3">
            <img src="assets/img/footer_logo.png" alt="logo" className="footer-logo mb-3" />

            <h5 className="footer-title">CONTACTS</h5>

            <p className="footer-text">
              Ceylonsman (Private) Limited <br />
              No: 199/D, Oruwala, Athurugiriya (10150), Sri Lanka
            </p>

            <p className="footer-text mt-2">info@ceylonsman.com</p>
            <p className="footer-text">+94 71 188 7338</p>

            <p className="footer-text">Available 24/7</p>

            <div className="footer-social mt-3">
              <FaInstagram />
              <FaFacebookF />
              <FaYoutube />
            </div>
          </div>

          {/* ================= Column 2 ================= */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="footer-title">EXPLORE</h5>
            <ul className="footer-list">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/destination">Destinations</Link></li>
              <li><Link to="/">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/services">Gift Vouchers</Link></li>
              <li><Link to="/packages">News & Trends</Link></li>
              <li><Link to="/contact">Sustainability</Link></li>
            </ul>
          </div>

          {/* ================= Column 3 ================= */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="footer-title">POLICIES</h5>
            <ul className="footer-list">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li>Cancellation Policy</li>
              <li><Link to="/Terms&Conditions">Terms & Condition</Link></li>
              
            </ul>
          </div>

          {/* ================= Column 4 ================= */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="footer-title">Subscribe to Newsletter</h5>

            <div className="newsletter-box d-flex align-items-center mt-3">
              <input type="email" className="newsletter-input" placeholder="Your Email" />
              <img src="assets/img/newsletter.svg" alt="send" className="send-icon" />
            </div>

            <p className="footer-text mt-3">
              Receive latest offers and promos without spam. You can cancel anytime.
            </p>
          </div>
        </div>

        {/* ================= Divider ================= */}
        <hr className="footer-divider" />

        {/* ================= Bottom Section ================= */}
        <div className="footer-bottom d-flex flex-column flex-md-row justify-content-between align-items-center">
          
          <img src="assets/img/registration.svg" width="200" alt="Reg" className="mb-3 mb-md-0" />

          <div className="payment-icons d-flex gap-3">
            <img src="/assets/img/payment_icon/Gpay.svg" width="50" alt="GPay" />
            <img src="/assets/img/payment_icon/Visa.svg" width="50" alt="Visa" />
            <img src="/assets/img/payment_icon/Master.svg" width="40" alt="Mastercard" />
            <img src="/assets/img/payment_icon/AE.svg" width="50" alt="Amex" />
            <img src="/assets/img/payment_icon/Union_Pay.svg" width="40" alt="Union" />
            <img src="/assets/img/payment_icon/Diners_C.svg" width="50" alt="Diners" />
            <img src="/assets/img/payment_icon/Alipay.svg" width="70" alt="Alipay" />
          </div>
        </div>

        <p className="footer-copy text-center mt-4">
          © {new Date().getFullYear()} Ceylonsman (Private) Limited. All rights reserved.
        </p>

      </div>
    </footer>
  );
}
